import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=1446c87c&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=1446c87c&prod&lang=scss&scoped=true"
import style1 from "./Course.vue?vue&type=style&index=1&id=1446c87c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1446c87c",
  null
  
)

export default component.exports